<template>
	<div :class="containerClass">
		<div class="color-gradient-header" />
		<div v-for="color in legendColors" :key="color" :style="{ backgroundColor: color }" class="color-gradient-color" />
		<div class="color-gradient-footer" />
		<div class="color-gradient-max">{{ realMax }} {{ units ? $t(units) : '' }}</div>
		<div class="color-gradient-min">{{ realMin }} {{ units ? $t(units) : '' }}</div>
	</div>
</template>

<script lang="ts">
import { toRef, computed } from 'vue';
import type { PropType } from 'vue';

import Consts from '@/api/Consts';

export default {
	components: {},
	props: {
		minValue: {
			type: Number,
			required: true,
		},
		maxValue: {
			type: Number,
			required: true,
		},
		colors: {
			type: Array as PropType<readonly string[]>,
			required: true,
		},
		units: {
			type: String,
			required: false,
			default: '',
		},
	},
	setup(props) {
		const colorsRef = toRef(props, 'colors');
		const minValueRef = toRef(props, 'minValue');
		const maxValueRef = toRef(props, 'maxValue');
		const unitsRef = toRef(props, 'units');
		const legendColors = computed(() => (minValueRef.value < maxValueRef.value) ? colorsRef.value : colorsRef.value.slice().reverse());
		const realMin = computed(() => Math.min(minValueRef.value, maxValueRef.value));
		const realMax = computed(() => Math.max(minValueRef.value, maxValueRef.value));
		const containerClass = computed(() => ['color-gradient-container', unitsRef.value ? 'color-gradient-container-with-units' : '']);
		return {
			realMin,
			realMax,
			legendColors,
			containerClass,
			dark0: Consts.COLORS.dark0,
		};
	},
}
</script>

<style scoped>
.color-gradient-container {
	position: relative;
	width: 75px;
}

.color-gradient-container.color-gradient-container-with-units {
	width: 90px;
}

.color-gradient-header,
.color-gradient-footer {
	width: 35px;
	height: 10px;
}

.color-gradient-header {
	border-bottom: 1px solid v-bind(dark0);
}

.color-gradient-footer {
	border-top: 1px solid v-bind(dark0);
}

.color-gradient-color {
	width: 30px;
	height: 15px;
}

.color-gradient-max,
.color-gradient-min {
	position: absolute;
	inset-inline-start: 40px;
	font-size: 12px;
}

.color-gradient-max {
	top: 0;
}

.color-gradient-min {
	bottom: 0;
}
</style>